<template>
    
    <div class="cc-app cc-accommodation-select mb-ms-2" v-if="accommodations && accommodations.length > 0">
            
        <select name="accommodation" class="cc-accommodation-select" v-model="settings.accommodation_id" @change="selectedAccommodation">
            <option value="null">{{ $t('All accommodations') }}</option>
            <option v-for="accommodation in accommodations" :key="accommodation.id" :value="accommodation.id">{{accommodation.name}}</option>
        </select>

    </div>

</template>

<style scoped>

@media (max-width: 767px) {

    .cc-accommodation-select {
        width: 100%;
    }

}

</style>

<script>
// import helpers from "@/helpers.js"
import class_accommodations from "../../api/accommodations/accommodations.js"
import { i18n } from "../../plugins/i18n";

import store from "../../store";
import { mapGetters } from "vuex";

export default {

    i18n,
    store,
    name: "cc-accommodation-select",

    // data(){
    //     return {
    //         accommodations: []
    //     }
    // },

    computed: {
        // map `this.administrationTest` to `this.$store.getters.administrationTest`
        ...mapGetters({
            settings: "app/settings",
            accommodations: "accommodations/get",
            administration: "administration/get",
            priceCalculation: "priceCalculation/get"
        }),

        // ...mapState("accommodations", [
        //     "accommodations",
        //     "accommodationsLoading",
        //     "accommodationsError"
        // ]),

    },

    watch: {

        administration(){

            if(this.settings && this.settings.admin_id){
                this.getAccommodations(); 
            }

        }

    },

    // model: {
	// 	prop: "accommodation_id",
	// 	event: "selected",
	// },

    methods: {

        getAccommodations(){

            try {

                const AccommodationsApi = new class_accommodations();
                
                AccommodationsApi.get().then((response) => {
                    
                    store.commit("accommodations/set", response)

                    // this.accommodations = response ;
                    // this.$emit("selectedAccommodations", this.accommodations);

                })

            } 
            catch (error) {
                console.error("cc-Accommodation-SelectError in get accommodations: " + error);    
            }
           
        },

        selectedAccommodation(){

            if(this.settings.accommodation_id == 'null'){ this.settings.accommodation_id = null ; }

            // console.log('this.accommodation_id', this.accommodation_id);

            store.commit('app/set_accommodation_id', this.settings.accommodation_id) ;
            store.dispatch('priceCalculation/get');

        }
        
    },

    created() {
        // if(store.state)
        store.dispatch("app/init")
        this.getAccommodations();
    },

    // props: {
        
    //     accommodation_id: {
    //         type: Number,
    //         default: null
    //     },

    // }

}
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/main";
</style>

